import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const provideMessageFeedback = {
  name: "provideMessageFeedback" as const,
  input: z.object({
    messageId: z.string(),
    threadId: z.string(),
    feedback: createEnum(["positive", "negative"]).optional(),
    comment: z.string().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
